import { FileEntity, FileTypeName } from 'api/types/entity';
import { lodash } from 'helpers';

interface Args {
  files: (FileEntity | undefined)[] | undefined;
  type: FileTypeName;
  uploadedByAdmin?: boolean;
}

export const parseListDocumentsFiles = (data: Args[]): FileEntity[] =>
  data
    .map(({ files, type, uploadedByAdmin }) =>
      lodash.compact(files).map((v) => ({
        ...v,
        type,
        uploadedByAdmin,
      }))
    )
    .flatMap((v) => v);
